import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
export const FigmaStarFilledIcon = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ _jsxs("svg", {
        ref: ref,
        ...props,
        fill: "none",
        "aria-hidden": "true",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ _jsx("g", {
                "clip-path": "url(#a)",
                children: /*#__PURE__*/ _jsx("path", {
                    fill: "currentColor",
                    d: "M8 0.390137L9.87882 6.21586L16 6.20248L11.04 9.78959L12.9443 15.607L8 11.9983L3.05573 15.607L4.96 9.78959L0 6.20248L6.12118 6.21586L8 0.390137Z",
                    fillOpacity: "0.8"
                })
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "16",
                        height: "16",
                        fill: "currentColor"
                    })
                })
            })
        ]
    }));
FigmaStarFilledIcon.displayName = "FigmaStarFilledIcon";
